import { Quote } from 'acscp/store';
import { Department } from 'acscp/api/models/customTypes/department';
import { QuoteType } from 'acscp/api/models/customTypes/quoteType';

export const isQuoteInAcmiWorkflow = (quote: Quote) =>
    quote.department === Department.ACMI && quote.quoteType === QuoteType.ACMI;
export const isQuoteInAcmiChartersWorkflow = (quote: Quote) =>
    quote.department === Department.ACMI && quote.quoteType !== QuoteType.ACMI;
